function setupProductList() {
  new Swiper(".na-product-list__carousel", {
    direction: "horizontal",
    keyboard: {
      enabled: true,
    },
    slidesPerView: "1",
    autoHeight: true, //enable auto height
    spaceBetween: 15,
    grabCursor: true,
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1536: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
    },
    navigation: {
      nextEl: ".na-product-carousel__next",
      prevEl: ".na-product-carousel__prev",
    },
  });
}
setupProductList();
